import { graphql } from "api/cms-website/generated";

export const TermLinkFragment = graphql(/* GraphQL */ `
    fragment TermLinkFragment on ComponentComponentsTermLink {
        id
        noMarginBottom
        termLinkText: text
    }
`);
